<template>
  <div class="col-6 card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 v-if="conceptPaymentType.id" class="mb-0">Editar tipo de concepto de pago</h3>
        <h3 v-else class="mb-0">Agregar un nuevo tipo de concepto de pago</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label"> Tipo de concepto de pago (*)</label>

                <el-input
                  v-model="formData.description"
                  v-validate="modelValidations.description"
                  name="description"
                  placeholder="Tipo de concepto de pago"
                />

                <small v-show="description.invalid" class="text-danger">
                  {{ getError('description') }}
                </small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';

export default {
  props: {
    conceptPaymentType: {
      type: Object,
      default: () => {
        return {
          description: null,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      formData: {
        description: this.conceptPaymentType.description || null,
      },

      modelValidations: {
        description: {
          required: true,
        },
      },
    };
  },

  computed: {
    ...mapFields(['description']),
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
